import { authenticatedFetch } from '../../../api/request';

export default async function getProfileApprovalRecord(doctorUserId) {
    return await authenticatedFetch(`/doctor-profile-management/profile-approval/${doctorUserId}`);
}
